export default {
  INTERVAL_TIME: {
    1: {'D': 15, 'C': 10}, // JP
    2: {'D': 5, 'C': 5}, // NZ
    3: {'D': 10, 'C': 10}, // SG
    5: {'D': 30, 'C': 30}, // PH
    122: {'D': 15, 'C': 15}, // KW
    126: {'D': 15, 'C': 10}, // BZ
    129: {'D': 15, 'C': 15}, // PE
    127: {'D': 15, 'C': 15}, // UK
    130: {'D': 15, 'C': 15}, // PR
    131: {'D': 15, 'C': 10}, // MX
    133: {'D': 15, 'C': 15} // MY
  },
  CLIENT_WEBSOCKET_URL: {
    testing: {
      1: 'wss://jf0io9g01l.execute-api.ap-southeast-1.amazonaws.com/dev?Authorization=c5e3391d-6f74-5b6c-9bd9-7247e311340e&ClientId=gms-dev&MarketId=jp&From=gms',
      2: 'wss://jf0io9g01l.execute-api.ap-southeast-1.amazonaws.com/dev?Authorization=c5e3391d-6f74-5b6c-9bd9-7247e311340e&ClientId=gms-dev&MarketId=nz&From=gms',
      3: null,
      5: null,
      122: null,
      126: null,
      127: null,
      129: null,
      130: 'wss://jf0io9g01l.execute-api.ap-southeast-1.amazonaws.com/dev?Authorization=c5e3391d-6f74-5b6c-9bd9-7247e311340e&ClientId=gms-dev&MarketId=pr&From=gms',
      131: 'wss://jf0io9g01l.execute-api.ap-southeast-1.amazonaws.com/dev?Authorization=c5e3391d-6f74-5b6c-9bd9-7247e311340e&ClientId=gms-dev&MarketId=mx&From=gms',
      133: null
    },
    development: {
      1: 'wss://jf0io9g01l.execute-api.ap-southeast-1.amazonaws.com/dev?Authorization=c5e3391d-6f74-5b6c-9bd9-7247e311340e&ClientId=gms-dev&MarketId=jp&From=gms',
      2: 'wss://jf0io9g01l.execute-api.ap-southeast-1.amazonaws.com/dev?Authorization=c5e3391d-6f74-5b6c-9bd9-7247e311340e&ClientId=gms-dev&MarketId=nz&From=gms',
      3: null,
      5: null,
      122: null,
      126: null,
      127: null,
      129: null,
      130: 'wss://jf0io9g01l.execute-api.ap-southeast-1.amazonaws.com/dev?Authorization=c5e3391d-6f74-5b6c-9bd9-7247e311340e&ClientId=gms-dev&MarketId=pr&From=gms',
      131: 'wss://jf0io9g01l.execute-api.ap-southeast-1.amazonaws.com/dev?Authorization=c5e3391d-6f74-5b6c-9bd9-7247e311340e&ClientId=gms-dev&MarketId=mx&From=gms',
      133: null
    },
    production: {
      1: 'wss://w4ju2ktta2.execute-api.ap-northeast-1.amazonaws.com/prod?Authorization=bf4d0e4c-7634-5ac5-8661-f9b6102ffc5a&ClientId=gms-apne1-prod&MarketId=jp&From=gms',
      2: 'wss://l7oxnqlmkg.execute-api.ap-southeast-2.amazonaws.com/prod?Authorization=28ba77a4-b881-5b69-8d51-87389573eb11&ClientId=gms-apse2-prod&MarketId=nz&From=gms',
      3: null,
      5: 'wss://fndc9ovvqf.execute-api.ap-southeast-1.amazonaws.com/prod?Authorization=59bd1b34-2e5b-5622-8404-492d762bf855&ClientId=gms-apse1-prod&MarketId=ph&From=gms',
      122: 'wss://ozlc7x7ni6.execute-api.me-south-1.amazonaws.com/prod?Authorization=2e70d234-76bb-51ea-bcbb-e18411e4f350&ClientId=gms-mes1-prod&MarketId=kw&From=gms',
      126: null,
      127: null,
      129: null,
      130: 'wss://7m5oapekxa.execute-api.sa-east-1.amazonaws.com/prod?Authorization=30ca1534-79da-5e46-bcf4-0f435b2e0cd8&ClientId=gms-sae1-prod&MarketId=pr&From=gms',
      131: null,
      133: 'wss://fndc9ovvqf.execute-api.ap-southeast-1.amazonaws.com/prod?Authorization=59bd1b34-2e5b-5622-8404-492d762bf855&ClientId=gms-apse1-prod&MarketId=my&From=gms',
    }
  },
  CLIENT_TIMEZONE: {
    1: 'Asia/Tokyo',
    2: 'Pacific/Auckland',
    3: 'Asia/Singapore',
    5: 'Asia/Manila',
    122: 'Asia/Kuwait',
    126: 'America/Sao_Paulo',
    127: 'Europe/London',
    129: 'America/Lima',
    130: 'America/Puerto_Rico',
    131: 'America/Mexico_City',
    133: 'Asia/Kuala_Lumpur'
  },
  GMS_SERVICES: [
    {
      value: 'order', text: 'Order'
    },
    {
      value: 'menu', text: 'Menu'
    },
    {
      value: 'outlet', text: 'Outlet'
    },
    {
      value: 'coupon', text: 'Coupon'
    },
    {
      value: 'customer', text: 'Customer'
    },
    {
      value: 'tenant', text: 'Tenant'
    },
    {
      value: 'payment', text: 'Payment'
    },
    {
      value: 'notification', text: 'Notification'
    },
    {
      value: 'ges', text: 'GES'
    },
    {
      value: 'pos', text: 'POS'
    }
  ],
  TRIGGER_NEW_FCD_BUILD_ALLOWED_CLIENTS: [2],
  USE_CUSTOMER_API_V4: [
    '2f28344b-2d60-4754-8985-5c23864a3737',
    '606dd890-1e5d-4898-853a-0ef434fff627'
  ],
  CLIENT_ABBREVIATION_ENUM: {
    JP: 1,
    NZ: 2,
    SG: 3,
    PH: 5,
    KW: 122,
    BZ: 126,
    UK: 127,
    PE: 129,
    PR: 130,
    MX: 131,
    MY: 133
  }
}



// WEBPACK FOOTER //
// ./src/utils/constants/constant.js